<template>
    <v-app v-if="sentimentPageReady">
        <v-layout wrap>
            <!-- Sentiment Graph -->
            <v-flex xs12 sm12 md8 lg8>
				<SentimentGraph
					:sentimentData = "sentimentData"
					:categoryColor="categoryColor"
                    :summaryDataReady="childComponentReady"
				/>
            </v-flex>
            <!-- Total Commments -->
            <v-flex  xs12 sm12 md4 lg4>
               <TotalCategoriesGraph
                       :categoryColor="categoryColor"
                       :categoryRangeOrdered="categoryRangeOrdered"
                       :summaryDataReady="childComponentReady"
                       name="Total Comments"
                       :isReaction="false"
               ></TotalCategoriesGraph>
            </v-flex>
            <!-- emotion bar chart -->
<!--            <v-flex d-flex xs12 sm12 md8 lg8>-->
<!--                <EmotionChart/>-->
<!--            </v-flex>-->
            <!-- emotion pie chart -->
<!--            <v-flex d-flex xs12 sm12 md4 lg4>-->
<!--                <EmotionPieChart/>-->
<!--            </v-flex>-->
            <!-- Topic Sentiment -->
            <v-flex xs12 sm12 md8 lg8>
                <TotalCategoriesGroupCount
                    :categoryColor="categoryColor"
                    :selectedTags="selectedTags"
                    :summaryData = "sentimentTagCloudData"
                    :limit="10"
                    :summaryDataReady="childComponentReady"
                />
            </v-flex>
            <!-- Tags Cloud -->
            <v-flex xs12 sm12 md4 lg4>
                <AppSearchComponent
                        :item-per-page="8"
                        :list-items="tags"
                        :ready="childComponentReady"
                        :searchable="true"
                        search-by="tag"
                >
                    <template v-slot:title>
                        <span class="subheading font-weight-regular section-title--color">Sentiments Drivers</span>
                    </template>
                    <template v-slot:no-items>No Tags Found</template>
                    <template v-slot:list-item="{listView}">
                        <v-list dense style="max-height:333px;">
                            <v-list-tile v-for="tag in listView" :key="tag.tag">
                                <v-list-tile-action style="min-width: 32px; margin-right: -5px;">
                                    <v-checkbox
                                            class="custom-checkbox-size"
                                            hide-details
                                            :ripple="false"
                                            color="bindezcolor"
                                            :value="tag.tag"
                                            v-model="selectedTags"
                                    ></v-checkbox>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        <h4 class="body-1">{{tag.tag}}</h4>
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <v-tooltip top>
                                    <template slot="activator" slot-scope="{on}">
                                        <v-chip
                                                v-on="on"
                                                small
                                                label
                                                color="bindezcolor"
                                                text-color="#fff"
                                        >
                                            {{tag.count | abbrNumber}}
                                        </v-chip>
                                    </template>
                                    <span>{{tag.count | formatNumber}}</span>
                                </v-tooltip>
                            </v-list-tile>
                        </v-list>
                    </template>
                </AppSearchComponent>
            </v-flex>

            <!-- Topic Cloud -->
            <v-flex xs12>
                <TopicCloud
                    :summaryData="sentimentTagCloudData"
                    :summaryDataReady="childComponentReady"
                />
            </v-flex>

            <!-- Emoji Cloud -->
            <v-flex xs12>
                <EmojiCloud name="Emoji Cloud" :summaryDataReady="childComponentReady"></EmojiCloud>
            </v-flex>
            <!-- Comments -->
            <v-flex xs12 sm12 md8 lg8>
                <v-card flat min-height="100%">
                    <AppComments
                            v-model="term"
                            :commentsReady="commentReady"
                            :commentsCount="monitorCommentsCount"
                            :comments="monitorAllComments"
                            @searchCommentsByTerm="searchCommentsByTerm"
                            ref="appCompo"
                    />
                    <div class="text-xs-center py-3">
                        <AppBindezPagination
                                v-if="commentReady && monitorCommentsCount > 0"
                                ref="pagination"
                                :length="pageLength"
                                :per-page="perPage"
                                v-model="page"
                                circle
                                @input="paginate"
                                :next-skip-count="skipCount"
                                color="bindezcolor"
                                total-visible="9"
                        >
                        </AppBindezPagination>
                    </div>
                </v-card>
            </v-flex>
            <!-- Filters -->
            <v-flex xs12 sm12 md4 lg4>
                <v-card flat>
                    <div>

                        <FolderFilter @filterByFolder="filterComments"></FolderFilter>
                        <v-divider class="divider-custom--width"></v-divider>


                        <SentimentFilter @filterBySentiment="filterComments"></SentimentFilter>
                        <v-divider class="divider-custom--width"></v-divider>


                        <TagsFilter v-model="tagsToFilter" :numOfTags="20" :tags="tags" @filterByTags="filterComments"></TagsFilter>
                        <v-divider class="divider-custom--width"></v-divider>

                        <FacebookTopMention name="Facebook Pages" v-model="pageFilter" @filter="filterComments" :ready="childComponentReady" :facebookTopMention="pagesAndCount"></FacebookTopMention>

                        <v-divider class="divider-custom--width"></v-divider>

                        <EmojiFilter @filterByEmoji="filterComments"></EmojiFilter>

                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-app>
    <div class="text-xs-center" v-else>
        <Spinner/>
        <span class="font-weight-bold display-1 description--color">Loading...</span>
    </div>
</template>
<script>
	/*eslint-disable */
	import VueWordCloud from "vuewordcloud";
	import {mapActions, mapState, mapGetters, mapMutations} from 'vuex';
	import moment from 'moment';
	import _cloneDeep from 'lodash/cloneDeep';
	import _chunk from 'lodash/chunk';
	import TopicCloud from "@/components/Sentiment/TopicCloud";
	import SentimentGraph from '@/components/Sentiment/SentimentGraph';
    import SentimentFilter from "@/components/Sentiment/SentimentFilter";
    import FolderFilter from "@/components/Sentiment/FolderFilter";
	import TagsFilter from "@/components/Sentiment/TagsFilter";
    import TotalCategoriesGroupCount from "@/components/TotalCategoriesGroupCount";
	import TotalCategoriesGraph from "@/components/TotalCategoriesGraph";
	import Spinner from '@/components/Spinner';
	import AppComments from "@/components/AppComments";
    import AppBindezPagination from '@/components/AppBindezPagination'
    import multiViews from '@/mixins/multiViews';
	import EmojiFilter from "../components/Sentiment/EmojiFilter";
	import EmojiCloud from "../components/Sentiment/EmojiCloud";
	import FacebookTopMention from "../components/Mention/FacebookTopMention";
	import AppSearchComponent from "../components/AppSearchComponent";
	import {fromZawgyiToUnicode} from "../utils/font";

	export default {
		name: "Sentiment",
		mixins: [multiViews],
		props: {
			monitor_uuid: {
				required: true,
				type: String
			}
		},
		data() {
			return {
				skipCount: 5,
                perPage: 10,
				monitorAllCommentsReady: false,
				addTagMenu: false,
				tagExist: false,
				visible: false,
				newTag: undefined,
				selectedTags: [],
				total: 0,
				skip: 0,
                categories: ['positive', 'negative', 'neutral', 'interest'],
				categoryColor: {
					negative: "#EB2929",
					positive: "#1AB177",
					neutral: "#EAC82A",
					interest: "#1F65C5",
					other: "#9e9e9e"
				},
			};
		},

		computed: {
			...mapState('sentiment', [
				'commentReady',
				'sentimentPageReady',
                'currentPage',
                'selectedSentiment',
                'selectedTag',
                'folder',
				'monitorAllComments',
                'monitorCommentsCount',
                'selectedEmoji',
                "selectedFacebookPages",
                "commentSearchTerm"
			]),

			...mapState('mention', [
				'summaryReady'
			]),

			...mapState([
				'monitor',
				'selectedDate',
				'facebookSummary',
			]),

            ...mapGetters('sentiment',[
            	"pagesAndCount"
            ]),

            fbCmtCategoryRange(){
                return this.facebookSummary.fbcomments.category_range;
            },

			categoryRangeOrdered() {
				return this.categories.map(category => {
					let foundCategory = this.fbCmtCategoryRange.find(cr => cr.value === category);
					return foundCategory || {value: category, count: 0}
				})
			},

            page:{
			    get(){
			    	return this.currentPage
                },
                set(value){
			    	this.setCurrentPage(value);
                }
            },

			pageLength() {
				return Math.ceil(this.monitorCommentsCount/ 10);
			},

            childComponentReady(){
				return this.summaryReady && this.sentimentPageReady;
            },

            sentimentData(){
				return {range: this.facebookSummary.fbcomments.category_range};
            },

            sentimentTagCloudData(){
				return this.facebookSummary.fbcomments.tags_sentiments_cloud_data
            },

            //list of custom tags.
            tags(){
	            return this.facebookSummary.fbcomments.tags_cloud_data
            },

            tagsToFilter:{
				get(){
					return this.selectedTag
                },set(tags){
					this.setSelectedTags(tags)
                }
            },

            pageFilter:{
				get(){
					return this.selectedFacebookPages
                },
                set(page){
					this.setSelectedFacebookPages(page);
                }
            },

            term:{
				get(){
					return this.commentSearchTerm;
                },
                set(term){
					this.setCommentSearchTerm(term);
                }
            }

		},

		watch: {

			selectedDate() {
				this.currentView = 1;
			},

			'facebookSummary.fbcomments.tags_cloud_data': {
				handler(val) {
					let tags = val ? _cloneDeep(val) : [];
					this.totalViews = Math.ceil(tags.length / 8);
					this.allKeywords = _chunk(tags ,8);
					this.keywordsView = this.allKeywords[0];
				},
				immediate: true
			}
		},

		methods: {
			...mapActions([
				'fetchMonitor',
				'fetchFacebookSummary',
				'createCommentTags',
			]),

			...mapActions('sentiment', [
				'fetchMonitorAllComments'
			]),

			...mapMutations('sentiment', [
				'setSentimentPageReady',
                'setMonitorAllComments',
                'setCurrentPage',
                'setDefaultSentimentState',
                "setSelectedTags",
                "setSelectedFacebookPages",
                "setCommentSearchTerm"
			]),

            ...mapMutations([
            	'setMonitor',
                'setSelectedMonitorComments',
                'setMonitorActionReady'
			]),

            ...mapMutations('monitors',[
            	'setReady'
            ]),

            filterComments(){
				this.skip = 0;
				this.setCurrentPage(1);
				this.fetchComments();
            },

			fetchComments() {
				this.setMonitorActionReady(false);
				let term = this.term && fromZawgyiToUnicode(this.term);
				this.$store.commit('sentiment/setCommentReady',false);
				this.fetchMonitorAllComments({
					monitor_uuid: this.monitor_uuid,
					timerange: this.selectedDate,
					skip: this.skip,
					categories: this.folder || this.selectedSentiment,
                    tags: this.selectedTag,
                    pages: this.selectedFacebookPages,
					term,
                    emojis:this.selectedEmoji
				}).then(() => {
					this.$store.commit('sentiment/setCommentReady', true);
					this.setMonitorActionReady(true);
				});
			},

			searchCommentsByTerm() {
				this.skip = 0;
				this.setCurrentPage(1);
				this.fetchComments()
			},

			paginate() {
				this.$ua.trackEvent("Paginate Comments", "click");
				this.setSelectedMonitorComments([]);
				this.skip = this.page === 1 ? 0 : 10 * (this.page - 1);
				this.fetchComments()
			},

		},

		components: {
			FacebookTopMention,
			AppSearchComponent,
			EmojiCloud,
			EmojiFilter,
			TopicCloud,
			TagsFilter,
			FolderFilter,
			SentimentFilter,
			AppComments,
			Spinner,
            AppBindezPagination,
			[VueWordCloud.name]: VueWordCloud,
			SentimentGraph,
            TotalCategoriesGroupCount,
            TotalCategoriesGraph,
		},

		filters: {
			formatDate(raw) {
				return moment(raw).format('h:mm D MMMM, YYYY')
			},
		},

		created() {
            let comments = this.monitorAllComments;
            let testComment;
            if (comments !== undefined) {
            	testComment = comments[0]
            }
			if ((this.monitor.monitor_uuid !== this.monitor_uuid)
                || ( testComment === undefined
                || testComment.monitor_uuid !== this.monitor.monitor_uuid)) {

				// this.setMonitor({data:{}});
				this.setSentimentPageReady(false);

				this.setDefaultSentimentState();
                // this.setReady(false);
				Promise.all([
					// this.fetchMonitor({monitor_uuid: this.monitor_uuid}),
					this.fetchMonitorAllComments({ monitor_uuid: this.monitor_uuid, timerange: this.selectedDate }),
				]).then(() => {
					this.monitorAllCommentsReady = true;
					this.setSentimentPageReady(true);
					// this.setReady(true);
				})
			}
		},
	};
</script>

<style scoped>

    .add-cursor {
        cursor: pointer;
    }

    div.v-radio > div.v-input--selection-controls__input {
        margin-right: 0;
    }



	.doughnut-chart-wrapper {
		margin-top: -14px;
		position: relative;
		width: 22vw;
	}

    /*.chart-container {*/
        /*width: 51vw;*/
        /*height: 75vh;*/
        /*position: relative;*/
	/*}*/

    .chart-container{
        width: 51vw;
        /*height: 75vh;*/
        position: relative;
    }

	.chart-wrapper > div:first-child{
		margin-top: -14px;
        margin-left: -14px;
    }

	.v-chip .v-icon--left {
		margin: 0 8px 0 -7px;
	}
</style>
